import * as React from 'react';

interface HeaderTitleProps {
	title?: string;
}

export const HeaderTitle: React.FC<HeaderTitleProps> = ({ title }) => {
	// Use provided title or fallback to hardcoded text
	const displayTitle = title || 'Ready to begin your journey?';

	// Split by line breaks to maintain formatting if needed
	const titleLines = displayTitle.split('\n');

	return (
		<h1 className='text-5xl leading-[80px] max-md:max-w-full max-md:text-4xl max-md:leading-10'>
			{titleLines.map((line, index) => (
				<React.Fragment key={index}>
					{line}
					{index < titleLines.length - 1 && <br />}
				</React.Fragment>
			))}
		</h1>
	);
};
